import Chance from '../utils/Chance'
import { uid } from '../utils/Common'
import Point from '../utils/Point'
import Card from './Card'
import GameBoard from './GameBoard'

export default class Deck {
  cards: Card[] = []

  id = uid()

  constructor(public board?: GameBoard, public location?: Point, ...cards: Card[]) {
    this.cards = cards
  }

  add(...cards: Card[]) {
    cards.forEach(card => {
      card.deck = this
      this.cards.unshift(card)
    })

    return this
  }

  remove(...cards: Card[]) {
    cards.forEach(card => {
      const i = this.cards.indexOf(card)
      if (i >= 0) {
        delete card.deck
        this.cards.splice(i, 1)
      }
    })

    return this
  }

  draw(to?: Deck, quantity = 1) {
    return this.cards.slice(0, quantity).map(card => card.moveTo(to, to?.board))
  }

  get size() {
    return this.cards.length
  }

  shuffle() {
    Chance.shuffle(this.cards)

    return this
  }
}
